<template>
  <div class="table-responsive">
    <table :id="tableid" class="table">
      <thead>
        <tr>
          <th v-for="column in simple_columns" scope="col">
            {{ $t('reports.displays.' + column.text) }}
          </th>
          <th v-for="column in complex_columns" scope="col">
            {{ $t('reports.displays.' + column.text) }}
          </th>
          <th v-for="column in complex_columns_details" v-if="showDetails" scope="col">
            {{ $t('reports.displays.' + column.text) }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="el in sortedReport">
          <td v-for="column in simple_columns">
            <span v-for="field in column.fields">{{ el[field] }} </span><br>
          </td>

          <td v-for="column in complex_columns">
            <div v-if="column.text != 'value'">
              {{ $t('reports.displays.fails') }} {{ el[column.field].fails_count }}/{{ el[column.field].total }}<br>
              <ul>
                <li v-for="fail in el[column.field]" v-if="fail.code">
                  {{ fail.code }} {{ fail.description }} <span v-if="fail.coef" class="text-muted small">(x{{ fail.coef }})</span><br>
                </li>
              </ul>
            </div>
            <div v-else>
              <span v-if="column.field == 'details_fails'">u {{ el[column.field].mu }}</span>
              <span v-else>&nbsp;</span>
              <ul>
                <li v-for="fail in el[column.field]" v-if="fail.code">
                  {{ fail.value }}<br>
                </li>
              </ul>
            </div>
          </td>
          <td v-for="column in complex_columns_details" v-if="showDetails">
            <div v-if="column.text != 'value'">
              {{ $t('reports.displays.fails') }} {{ el[column.field].fails_count }}/{{ el[column.field].total }}<br>
              <ul>
                <li v-for="fail in el[column.field]" v-if="fail.code">
                  {{ fail.code }} {{ fail.description }} <span v-if="fail.coef" class="text-muted small">(x{{ fail.coef }})</span><br>
                </li>
              </ul>
            </div>
            <div v-else>
              <span v-if="column.field == 'details_fails'">u {{ el[column.field].mu }}</span>
              <span v-else>&nbsp;</span>
              <ul>
                <li v-for="fail in el[column.field]" v-if="fail.code">
                  {{ fail.value }}<br>
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'SynthesisDisplay',

  props: {
    report: {
      type: Array,
      required: true
    },
    tableid: {
      type: String,
      required: true
    },
    showDetails: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    simple_columns: [{ text: 'requirements', fields: ['code', 'description'] }, { text: 'value', fields: ['value'] }],
    complex_columns: [{ text: 'prioritary', field: 'prioritary_fails' }, { text: 'value', field: 'prioritary_fails' }],
    complex_columns_details: [{ text: 'details', field: 'details_fails' }, { text: 'value', field: 'details_fails' }]
  }),

  computed: {
    sortedReport: function () {
      var field = 'code'
      return this.filteredReport.sort(this.sortCodeCallback(1))
    },

    filteredReport: function () {
      return this.report.filter(x => x.prioritary_fails.fails_count > 0 || x.details_fails.fails_count > 0)
    }
  },

  mounted () {

  },

  methods: {
    sortCodeCallback (order) {
      var f = function (a, b) {
        var codesA = a.code.split('.').map(x => parseInt(x))
        var codesB = b.code.split('.').map(x => parseInt(x))
        var lenA = codesA.length
        var lenB = codesB.length
        var minLen = lenA < lenB ? lenA : lenB
        for (var i = 0; i < minLen; i++) {
          if (codesA[i] < codesB[i]) { return -order }
          if (codesA[i] > codesB[i]) { return order }
        }
        return order * (lenA - lenB)
      }
      return f
    }
  }
}
</script>
<style>
  ul {
    list-style: none;
  }
</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/SynthesisDisplay.vue